import React from 'react'
import ContentLoader from 'react-content-loader'
import {Col, Media, Row} from "reactstrap"
import moment from "moment"
import assets from "../../../util/assets";
import "./tipgoalcontributors.css";

const MyLoader = () => (
    <ContentLoader
        height={240}
        speed={1}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
        viewBox="0 0 380 70">

        {/* Only SVG shapes */}
        <rect x="0" y="0" rx="5" ry="5" width="70" height="70"/>
        <rect x="80" y="17" rx="4" ry="4" width="300" height="13"/>
        <rect x="80" y="40" rx="3" ry="3" width="250" height="10"/>

    </ContentLoader>
)

const getTipArray = (props) => {
    if (props.tip &&
        props.tip !== null &&
        props.tip.hasOwnProperty("tipGoalDataList") &&
        props.tip.tipGoalDataList !== null &&
        props.tip.tipGoalDataList.hasOwnProperty("data") &&
        props.tip.tipGoalDataList.data !== null &&
        props.tip.tipGoalDataList.data.hasOwnProperty("tips")) {
        return props.tip.tipGoalDataList.data.tips;
    }
    return [];
};

const TipGoalContributors = (props) => {
    const tips = getTipArray(props);

    if (tips.length > 0) {
        return (
            <div className="tip-goal-contributors">
                {
                    tips.map((tip, index) => (
                        <div key={`tip-goal-contributors-${index}`}>
                            {
                                index !== 0 && <div className="tip-list-seperator"/>
                            }
                            <Media className="p-2 mb-2">

                                <Media left middle href="#" className="position-relative" style={{marginTop:6}}>
                                    <Media object
                                           src={tip.profile_pic != null ? tip.profile_pic : assets.user_placeholder}
                                           alt="Generic placeholder image"
                                           className="rounded-circle square-40"
                                    />
                                    {
                                        tip.is_favourite &&
                                        <Media object
                                               src={assets.favourite_icon_enabled}
                                               alt="Favourite image"
                                               className="favourite-icon"
                                        />
                                    }
                                </Media>
                                <Media body>
                                    <Row className="mx-0">
                                        <Col md="9" sm="9" className="pr-0 text-left">
                                            <Media heading
                                                   className="text-left tipUserName text-uppercase"
                                                   style={{margin: "5px 0px"}}>
                                                {tip.username}.
                                                <div>
                                                    <span
                                                        className="has-contributed-tip">has contributed like goal{" . "}</span>
                                                    <span
                                                        className="min-ago">{moment.utc(tip.created_at).format("hh:mm A")}</span>
                                                </div>
                                            </Media>
                                        </Col>
                                        <Col md="3" sm="3" className="px-0">
                                            <p className="text-right poundValue"
                                               style={{margin: "5px 0px"}}>
                                                {tip.amount_formatted}
                                            </p>
                                        </Col>
                                    </Row>
                                </Media>
                            </Media>
                        </div>
                    ))
                }
            </div>
        )
    } else {
        return (
            <div className="tip-goal-contributors">
                <MyLoader/>
            </div>
        )
    }
};

export default TipGoalContributors;
